import styled from "styled-components";

const Mydiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export default Mydiv;